<template>
    <div class="wrapper">
        <div class="s">
            <div class="s-list">
                <div class="s-item" @click="goDetail(item)" v-for="(item, index) in showList" :key="index">
                    <div class="s-item-img">
                        <img :src="item.icon" class="image" />
                    </div>
                    <div class="s-item-title">{{ item.name }}</div>
                    <div class="s-item-date">{{ formatDate(item.createTime) }}</div>
                </div>
            </div>
        </div>
        <div v-if="list.length === 0" class="no-data">
            <span>暂无数据</span>
        </div>
        <van-pagination v-if="list.length > 0" @change="change()" v-model="currentPage" :total-items="total"
            :show-page-size="5" :items-per-page="3" force-ellipses />
    </div>
</template>
<script>
import Vue from 'vue';
import { Pagination } from 'vant';
Vue.use(Pagination);
import { get } from "@/request/http";

export default {
    components: {

    },

    data() {
        return {
            total: 0,
            page: 1,
            showList: [],
            list: [],
            currentPage: 1,
            limit: 3,
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        change() {
            this.page = this.currentPage;
            this.loadData();
        },
        loadData() {
            get(
                `/gbs/portal/portal/topic?limit=${this.limit}&page=${this.page}`
            ).then((res) => {
                if (res.code !== 0) {
                    this.$Toast.fail(res.msg);
                    return;
                }
                this.total = res.data.length || 0;
                this.list = res.data || [];
                this.list = this.list.reduce((acc, cur, index) => {
                    const i = Math.floor(index / 3);
                    if (!acc[i]) {
                        acc[i] = [];
                    }
                    acc[i].push(cur);
                    return acc;
                }, []);
                this.showList = this.list[this.page - 1] || [];
            });
        },
        goDetail(item) {
            this.$router.push({
                path: "/newsList",
                query: {
                    categoryId: item.id,
                    ztIMG: item.logo || "",
                    title: item.name || '热门专题',
                },
            });
        },
        formatDate(date) {
            let year = date.substring(0, 4);
            let month = date.substring(4, 6);
            let day = date.substring(6, 8);
            return `${year}-${month}-${day} `;
        },
    },
};
</script>

<style lang="scss" scoped>

.wrapper {
    position: relative;
    width: 100vw;
    min-height: 100vh;
    overflow-x: hidden;
    padding: 0;

    ::v-deep .van-pagination {
        position: fixed;
        bottom: calc(20px + constant(safe-area-inset-bottom));
        bottom: calc(20px + env(safe-area-inset-bottom));
        left: 50%;
        width: 90%;
        transform: translateX(-50%);
        margin-top: 20px;
        text-align: center;
        .van-pagination__item {
            color: #ba060f;
        }
    
        .van-pagination__item--active {
            background-color: #ba060f;
            color: #fff
        }
    
        .van-pagination__item:active {
            background-color: #ba060f;
            color: #fff
        }

    
    }

    .s {
        width: 100%;
        padding: 0 10px;

        .s-list {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            justify-content: center;

            .s-item {
                width: 100%;
                margin-top: 10px;
                background: #FFFFFF;
                border-radius: 8px;

                .s-item-img {
                    width: 100%;
                    height: 340px;
                    overflow: hidden;
                    border-radius: 5px;

                img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 5px;
                    }
                }

                .s-item-title {
                    height: 50px;
                    line-height: 50px;
                    font-size: 34px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    margin: 10px 0 0 20px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                }

                .s-item-date {
                    height: 30px;
                    line-height: 30px;
                    font-size: 24px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    margin: 10px 0 20px 20px;
                    color: #999999;
                }

            }
        }
    }

    .no-data {
        height: 70px;
        font-size: 28px;
        font-family: Source Han Sans SC VF, Source Han Sans SC VF;
        font-weight: 500;
        color: #333333;
        line-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

}
</style>